const parseJSON = (response: Response) => response.json();

export default parseJSON;
